import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";
import ProfileCard from "./ProfileCard";

import FormInput from "../../common/searchconsultant/FormInput";
import EmailField from "../../common/searchconsultant/EmailField";
import PasswordField from "../../common/searchconsultant/PasswordField";
import PhoneField from "../../common/searchconsultant/PhoneField";
import SingleSelectField from "../../common/searchconsultant/SingleSelectField";

export default function PersonalInformationCard({

    data,
    errors,
    wilayas = [],
    communes = [],
    handleChange

}) {

const { t } = useTranslation();
const { language } = useLanguage();
    return (

        <ProfileCard
            title={t("monProfile.personalInformation")}
            icon="bi-person-vcard"
        >

            <FormInput
                label={t("monProfile.fullName")}
                name="fullName"
                value={data.fullName}
                onChange={handleChange}
                error={errors.fullName}
                required
                icon="bi-person"
            />

            <EmailField
                label={t("monProfile.email")}
                name="email"
                value={data.email}
                onChange={handleChange}
                error={errors.email}
                disabled
                icon="bi-envelope"
            />

            <PasswordField
                label={t("monProfile.password")}
                name="password"
                value={data.password}
                onChange={handleChange}
                error={errors.password}
                disabled
                icon="bi-lock"
            />

            <PhoneField
                label={t("monProfile.phoneNumber")}
                name="phoneNumber"
                value={data.phoneNumber}
                onChange={handleChange}
                error={errors.phoneNumber}
                icon="bi-telephone"
            />

            <div className="row">

                <SingleSelectField
                    col="col-md-6"
                    labelCol={3}
                    inputCol={9}
                    label={t("monProfile.wilaya")}
                    name="wilayaId"
                    value={data.wilayaId}
                    options={wilayas}
                    optionValue="id"
                    optionLabel={(w) =>
                        `${w.codeWilaya} -  ${getLabel(w, "wilaya", language)}`
                    }
                    onChange={handleChange}
                    error={errors.wilayaId}
                    icon="bi-map"
                />

<SingleSelectField
    col="col-md-6"
    labelCol={3}
    inputCol={9}
    label={t("monProfile.commune")}
    name="communeId"
    value={data.communeId}
    options={communes}
    optionValue="id"
    optionLabel={(c) => getLabel(c, "commune", language)}
    onChange={handleChange}
    error={errors.communeId}
    icon="bi-pin-map"
/>

            </div>

            <FormInput
                label={t("monProfile.address")}
                name="address"
                value={data.address}
                onChange={handleChange}
                error={errors.address}
                icon="bi-geo-alt"
            />

            <SingleSelectField
                label={t("monProfile.userType")}
                name="falahOrProf"
                value={data.falahOrProf}
                options={[
                    {
                        id: "F",
                        libelle: t("monProfile.farmer")
                    },
                    {
                        id: "P",
                        libelle: t("monProfile.professional")
                    },
                    {
                        id: "S",
                        libelle: t("monProfile.supplier")
                    }
                ]}
                optionValue="id"
                optionLabel="libelle"
                onChange={handleChange}
                error={errors.falahOrProf}
                icon="bi-person-badge"
            />

        </ProfileCard>

    );

}